// src/features/uninsured/uninsuredItemSlice.ts

import { createSlice } from "@reduxjs/toolkit"
import { UninsuredItemSerializer } from "@/types/uninsured"
import { fetchUninsuredItems } from "@core/api/uninsuredApi"

interface UninsuredItemState {
  uninsuredItems: UninsuredItemSerializer[]
  loading: boolean
  error: string | null
}

const initialState: UninsuredItemState = {
  uninsuredItems: [],
  loading: false,
  error: null,
}

const uninsuredItemSlice = createSlice({
  name: "uninsuredItem",
  initialState,
  reducers: {
    // 모든 아이템을 초기화할 때
    clearUninsuredItem(state) {
      state.uninsuredItems = []
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchUninsuredItems.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUninsuredItems.fulfilled, (state, action) => {
        state.loading = false
        state.uninsuredItems = action.payload || []
        state.error = null
      })
      .addCase(fetchUninsuredItems.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "알 수 없는 오류 발생"
      })
  },
})

export const { clearUninsuredItem } = uninsuredItemSlice.actions

export default uninsuredItemSlice.reducer
